import React from "react";
import Spacer2 from "../Components/common/Spacer2";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import ProductSimilarBulasikMakineDeterjanlari from "../Components/similar/ProductSimilarBulasikMakineDeterjanlari";
import SEO from "../Components/common/SEO";

// component ProductSimilarBulasikMakineDeterjanlariPage
function ProductSimilarBulasikMakineDeterjanlariPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/bulasikmakinedeterjanlari`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Benzer Ürünler - Bulaşık Makine Deterjanları",
    "url": "https://seymenkimya.com/bulasikmakinedeterjanlari",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "Product",
            "name": "Bulaşık Makina Deterjanı",
            "url": "https://seymenkimya.com/bulasikmakinedeterjanlari",
            "image": "https://seymenkimya.com/assets/images/product/bulasikmakinedeterjani.webp"
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "Product",
            "name": "Bulaşık Deterjanı Lüks",
            "url": "https://seymenkimya.com/bulasikdeterjaniluks",
            "image": "https://seymenkimya.com/assets/images/product/bulasikdeterjaniluks.webp"
          }
        },
        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "Product",
            "name": "Bulaşık Deterjanı Ekstra",
            "url": "https://seymenkimya.com/bulasikdeterjaniekstra",
            "image": "https://seymenkimya.com/assets/images/product/bulasikdeterjaniekstra.webp"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Bulaşık Makina Deterjanları | Seymen Kimya"
        description="Endüstriyel bulaşık makinaları için deterjan ve parlatıcı çeşitlerini inceleyin."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/20-kg/6.webp`}
        structuredData={structuredData}
      />
      <PageHeader title={t("BULAŞIK MAKİNA DETERJANLARI")} />
      <Spacer2 />
      <ProductSimilarBulasikMakineDeterjanlari />
    </>
  );
}

export default ProductSimilarBulasikMakineDeterjanlariPage;